'use client'

import { MicrophoneActivity, useToggleLocalMute } from 'amazon-chime-sdk-component-library-react'
import { useTranslations } from '@/lib/next-shim'

import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined'
import MicOffOutlinedIcon from '@mui/icons-material/MicOffOutlined'

type AudioInputControlProps = {
  attendeeId?: string
}

export function AudioInputControl(props: AudioInputControlProps) {
  const { attendeeId } = props
  const { muted, toggleMute } = useToggleLocalMute()
  const t = useTranslations('meetingControls.microphone')
  const tooltip = muted ? t('unmute') : t('mute')

  return (
    <div className="ds-tooltip" data-tip={tooltip}>
      <button
        type="button"
        className="flex rounded-full bg-white/10 p-2 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onClick={toggleMute}
        aria-label={tooltip}
      >
        {attendeeId ? (
          <MicrophoneActivity attendeeId={attendeeId} className="h-5 w-5" />
        ) : muted ? (
          <MicOffOutlinedIcon className="h-5 w-5" />
        ) : (
          <MicNoneOutlinedIcon className="h-5 w-5" />
        )}
      </button>
    </div>
  )
}
